import { firestore, storage } from "../firebase.js";
import store from "../store";
import moment from "moment";

const state = {
  tiempo_limite: null,
  todosLosProyectos: [],
  todosLosProyectosUsuarios: [],
  proyectosFiltrados: [],

  proyectosCategoria: [],
  proyectoUsuario: null,
  //recibe el query si el estado tiene la informacion de los proyectos no se activa
  //si no lo tiene se activa
  projectsListener: () => {},
};

//
const mutations = {
  setProyectos(state, Filtrados) {
    state.proyectosFiltrados = Filtrados;
  },
  tiempo_limite(state, limite) {
    state.tiempo_limite = limite;
  },
  nuevoProyecto(state, proyectos) {
    state.nuevoProyecto = proyectos;
  },
  obtenerProyectosCategoria(state, categorias) {
    state.proyectosCategoria = categorias;
  },
  obtenerTodosLosProyectos(state, proyectos) {
    state.todosLosProyectos = proyectos;
  },

  obtenerProyectosUsuariosCommit(state, proyectosUsuario) {
    state.todosLosProyectosUsuarios = proyectosUsuario;
  },

  //mutacion para estar a la escuchar de lo que pase si se necesita o no activar el query
  setProjectsListener(state, listener) {
    if (listener) {
      //si listener tiene algo se agrega al estado
      state.listener = listener;
    } else {
      //si no, se lanza la funcion
      state.projectsListener();
    }
  },

  subirProyectoUsuario(state, proyectoUsuario) {
    state.proyectoUsuario = proyectoUsuario;
  },
};

const actions = {
  nuevoIdProyecto(context, { idUser }) {
    return firestore
      .collection("usuarios")
      .doc(idUser)
      .collection("proyectos_usuario")
      .doc();
  },
  async obtenerTodosLosProyectos({ commit }) {
    const query = firestore.collectionGroup("proyectos").onSnapshot(doSnapshot);
    commit("setProjectsListener", query);

    function doSnapshot(snapshot) {
      const proyectos = [];
      snapshot.forEach((doc) => {
        let proyecto = doc.data();
        proyecto.id = doc.id;

        proyectos.unshift(proyecto);
      });

      commit("obtenerTodosLosProyectos", proyectos);
    }
  },
  /* obtener todos los proyectos de la comunidad  */
  async obtenerProyectosUsuarios({ commit }) {
    const query = firestore
      .collectionGroup("proyectos_usuario")
      .onSnapshot(doSnapshot);
    commit("setProjectsListener", query);

    function doSnapshot(snapshot) {
      const proyectosUsuario = [];
      snapshot.forEach((doc) => {
        let proyectoUsuario = doc.data();
        proyectoUsuario.id = doc.id;

        proyectosUsuario.unshift(proyectoUsuario);
      });

      commit("obtenerProyectosUsuariosCommit", proyectosUsuario);
    }
  },

  async obtenerProyectosCategoria({ commit }, { idCategoria }) {
    const proyectos = [];
    const proyectosfirestore = await firestore
      .collection("categorias")
      .doc(idCategoria)
      .collection("proyectos")
      .get();
    proyectosfirestore.docs.forEach((doc) => {
      const proyectos = doc.data();
      proyectos.id = doc.id;
      proyectos.push(proyectos);
    });
    commit("obtenerProyectosCategoria", proyectos);
  },

  limpiarStore({ commit }) {
    commit("obtenerTodosLosProyectos", []);
    commit("obtenerProyectosCategoria", []);
  },

  /* subir proyectos seleccionado al usuario */
  async proyectoUsuario(
    { commit, state },
    {
      idUser,
      nombreUsuario,
      username,
      idProyecto,
      idProyectoUsuario,
      titulo,
      area,
      sub_area,
      proyectohtml,
      puntos,
      categoria,
      imagen,
      tipoProyecto,
    }
  ) {
    let proyectos = await firestore
      .collection("usuarios")
      .doc(idUser)
      .collection("proyectos_usuario")
      .doc(idProyectoUsuario)
      .set({
        idProyecto: idProyecto,
        idUser: idUser,
        idProyectoUsuario: idProyectoUsuario,
        nombreUsuario: nombreUsuario,
        username: username,
        titulo: titulo,
        area: area,
        sub_area: sub_area,
        proyecto: proyectohtml,
        puntos: puntos,
        categoria: categoria,
        imagen: imagen,
        activo: true,
        limite: state.tiempo_limite,
        tipoProyecto: tipoProyecto,
        fechaInicio: new Date(),
      });
    commit("subirProyectoUsuario", proyectos);
  },

  /* iniciar proyectos */
  async IniciarProyecto(
    { commit, rootState, dispatch },
    { Dias, Horas, Minutos, Segundos }
  ) {
    let final = moment().add({
      days: Dias,
      hours: Horas,
      minutes: Minutos,
      seconds: Segundos,
    });

    await commit("tiempo_limite", moment(final).format("DD/MM/YYYY HH:mm:ss"));
    let iniciar = setTimeout(() => {
      store.dispatch("proyectos/proyectoIniciado");
      window.location.reload();
    }, 2000);

    clearInterval(iniciar);
  },

  /* proyectos iniciado */
  async proyectoIniciado({ rootState }) {
    let proyectos = rootState.usuario.proyectosUsuario;
    let tiempoFinal = proyectos.filter((proyectos) => {
      return proyectos.activo === true;
    });
    let tiempoParse = moment(tiempoFinal[0].limite, "DD/MM/YYYY HH:mm:ss");
    return tiempoParse;
  },

  async subirImagenesProyecto(
    context,
    { nameImage, image, idUsuario, idProyecto }
  ) {
    let now = new Date();

    const uploadPhoto = () => {
      let direccion = `usuarios/${idUsuario}/proyectos/${idProyecto}/${nameImage}-image.png`;
      return storage.ref(direccion).put(image);
    };

    function getDownloaderURL(ref) {
      return ref.getDownloadURL();
    }

    try {
      let upload = await uploadPhoto();
      return await getDownloaderURL(upload.ref);
    } catch (error) {
      console.log(error);
    }
  },

  /* pdf a revision */
  async subirPDFARevision(context, { pdf_url, idUsuario, idProyecto, nombre }) {
    const uploadPDF = () => {
      let direccion = `usuarios/${idUsuario}/proyectos-revision/${idProyecto}/${nombre}.pdf`;
      return storage.ref(direccion).put(pdf_url);
    };

    function getDownloaderURL(ref) {
      return ref.getDownloadURL();
    }

    try {
      let upload = await uploadPDF();
      return await getDownloaderURL(upload.ref);
    } catch (error) {
      console.log(error);
    }
  },

  /* pdf a proyecto */
  async subirPDF(context, { pdf_url, idUsuario, idProyecto, nombre }) {
    const uploadPDF = () => {
      let direccion = `usuarios/${idUsuario}/proyectos/${idProyecto}/${nombre}.pdf`;
      return storage.ref(direccion).put(pdf_url);
    };

    function getDownloaderURL(ref) {
      return ref.getDownloadURL();
    }

    try {
      let upload = await uploadPDF();
      return await getDownloaderURL(upload.ref);
    } catch (error) {
      console.log(error);
    }
  },

  /* proyecto terminado, enviar a revisión */
  async revisionProyectoUsuario(
    context,
    {
      idUsuario,
      idProyectoUsuario,
      email,
      titulo,
      descripcion,
      mensaje,
      reqAValidar,
      pdf,
      vecesEnviado,
    }
  ) {
    const nuevaData = {};
    let activo = false;
    let revision = true;
    let fechaFin = new Date();
    let tiempoFin = moment().format("DD/MM/YYYY HH:mm:ss");
    nuevaData.activo = activo;
    if (descripcion) {
      nuevaData.descripcion = descripcion;
      nuevaData.veces = vecesEnviado;
    }
    if (email) {
      nuevaData.email = email;
    }

    if (pdf) {
      nuevaData.titulo = titulo;
      nuevaData.mensaje = mensaje;
      nuevaData.pdf = pdf;
      nuevaData.revision = revision;
      nuevaData.limite = tiempoFin;
      nuevaData.terminado = true;
      nuevaData.fechaFin = fechaFin;
      nuevaData.validar = reqAValidar;
    }
    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .collection("proyectos_usuario")
      .doc(idProyectoUsuario)
      .update(nuevaData);
  },

  /* proyecto terminado, actualizacion */
  async actualizarProyectoUsuario(
    context,
    { idUsuario, idProyectoUsuario, titulo, descripcion, imagenes }
  ) {
    const nuevaData = {};
    let activo = false;
    let problema = "";
    let objetivo = "";
    let imagen = "";
    let fechaFin = new Date();
    let tiempoFin = moment().format("DD/MM/YYYY HH:mm:ss");
    nuevaData.activo = activo;
    nuevaData.problema = problema;
    nuevaData.objetivo = objetivo;
    nuevaData.imagen = imagen;
    if (descripcion) {
      nuevaData.descripcion = descripcion;
    }
    if (titulo) {
      nuevaData.titulo = titulo;
      nuevaData.imagenes = imagenes;
      nuevaData.limite = tiempoFin;
      nuevaData.terminado = true;
      nuevaData.revision = false;
      nuevaData.fechaFin = fechaFin;
      nuevaData.habilidadesRequeridas = [];
      nuevaData.requerimientos = [];
      nuevaData.requisitos = null;
    }

    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .collection("proyectos_usuario")
      .doc(idProyectoUsuario)
      .update(nuevaData);
  },
  /* ---------------------------------Frontend------------------------------------ */
  /* subir proyecto seleccionado frontend */

  async subirArchivosHtmlCss(
    context,
    { archivo, tipo, titulo, nombre, extension, idUsuario, idProyecto }
  ) {
    let now = new Date();

    const uploadFile = () => {
      let direccion = `usuarios/${idUsuario}/proyectos/${idProyecto}/${titulo}/${nombre}.${extension}`;
      const metadata = {
        contentType: tipo,
        customMetadata: {
          fileName: `${nombre}.${extension}`
        }
      };
      return storage.ref(direccion).put(archivo, metadata);
    };

    function getDownloaderURL(ref) {
      return ref.getDownloadURL();
    }

    try {
      let upload = await uploadFile();
      return await getDownloaderURL(upload.ref);
    } catch (error) {
      console.log(error);
    }
  },

  async revisionrchivosHtmlCss(
    context,
    { archivo, tipo, titulo, nombre, extension, idUsuario, idProyecto }
  ) {
    let now = new Date();

    const uploadFile = () => {
      let direccion = `usuarios/${idUsuario}/proyectos-revision/${idProyecto}/${titulo}/${nombre}.${extension}`;
      const metadata = {
        contentType: tipo,
        customMetadata: {
          fileName: `${nombre}.${extension}`
        }
      };
      return storage.ref(direccion).put(archivo, metadata);
    };

    function getDownloaderURL(ref) {
      return ref.getDownloadURL();
    }

    try {
      let upload = await uploadFile();
      return await getDownloaderURL(upload.ref);
    } catch (error) {
      console.log(error);
    }
  },

  async revisionProyectoFrontend(
    context,
    {
      idUsuario,
      idProyectoUsuario,
      email,
      titulo,
      descripcion,
      mensaje,
      archivos,
      vecesEnviado,
      repositorio,
      demo,
    }
  ) {
    const nuevaData = {};
    let activo = false;
    let revision = true;
    let fechaFin = new Date();
    let tiempoFin = moment().format("DD/MM/YYYY HH:mm:ss");
    nuevaData.activo = activo;
    if (descripcion) {
      nuevaData.descripcion = descripcion;
      nuevaData.veces = vecesEnviado;
    }
    if (email) {
      nuevaData.email = email;
    }
      nuevaData.titulo = titulo;
      nuevaData.mensaje = mensaje;
      nuevaData.archivos = archivos;
      nuevaData.revision = revision;
      nuevaData.limite = tiempoFin;
      nuevaData.terminado = true;
      nuevaData.fechaFin = fechaFin;
      nuevaData.repositorio = repositorio;
      nuevaData.demo = demo;
    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .collection("proyectos_usuario")
      .doc(idProyectoUsuario)
      .update(nuevaData);
  },


  async revisionProyectoCursoFrontend(
    context,
    {
      idUsuario,
      idProyectoUsuario,
      email,
      titulo,
      proyecto,
      secciones,
      codigo,
      mensaje,
      vecesEnviado,
    }
  ) {
    const nuevaData = {};
    let activo = false;
    let revision = true;
    let fechaFin = new Date();
    let tiempoFin = moment().format("DD/MM/YYYY HH:mm:ss");
    nuevaData.activo = activo;
    if (descripcion) {
      nuevaData.descripcion = proyecto;
      nuevaData.veces = vecesEnviado;
    }
    if (email) {
      nuevaData.email = email;
    }
      nuevaData.titulo = titulo;
      nuevaData.mensaje = mensaje;
      nuevaData.secciones = secciones;
      nuevaData.revision = revision;
      nuevaData.codigo = codigo;
      nuevaData.limite = tiempoFin;
      nuevaData.terminado = true;
      nuevaData.fechaFin = fechaFin;
    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .collection("proyectos_usuario")
      .doc(idProyectoUsuario)
      .update(nuevaData);
  },

  /* terminado frontend */
  async actualizarProyectoUsuarioFrontend(
    context,
    {
      idUsuario,
      idProyectoUsuario,
      titulo,
      imagen,
      descripcion,
      repositorio,
      demo,
    }
  ) {
    const nuevaData = {};
    let activo = false;
    let problema = "";
    let objetivo = "";
    let fechaFin = new Date();
    let tiempoFin = moment().format("DD/MM/YYYY HH:mm:ss");
    nuevaData.activo = activo;
    nuevaData.problema = problema;
    nuevaData.objetivo = objetivo;
    nuevaData.imagen = imagen;
    nuevaData.repositorio = repositorio;
    nuevaData.demo = demo;

    if (descripcion) {
      nuevaData.descripcion = descripcion;
    }
    if (titulo) {
      nuevaData.titulo = titulo;
      nuevaData.limite = tiempoFin;
      nuevaData.terminado = true;
      nuevaData.revision = false;
      nuevaData.fechaFin = fechaFin;
      nuevaData.requerimientos = [];
    }

    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .collection("proyectos_usuario")
      .doc(idProyectoUsuario)
      .update(nuevaData);
  },

  async proyectoUsuarioFrontend(
    { commit, state },
    {
      idUser,
      nombreUsuario,
      username,
      idProyecto,
      idProyectoUsuario,
      titulo,
      area,
      sub_area,
      proyectohtml,
      puntos,
      categoria,
      imagen,
      tipoProyecto,
      isHtml,
      isCss,
      isJs,
      reqHtml,
      reqCss,
      reqJs,
      requerimientos,
      tipo,
      tutoria,
      secciones,
      codigo,
    }
  ) {
    if (tipo === "inicial") {
      let proyectos = await firestore
        .collection("usuarios")
        .doc(idUser)
        .collection("proyectos_usuario")
        .doc(idProyectoUsuario)
        .set({
          idProyecto: idProyecto,
          idUser: idUser,
          idProyectoUsuario: idProyectoUsuario,
          nombreUsuario: nombreUsuario,
          username: username,
          titulo: titulo,
          area: area,
          sub_area: sub_area,
          proyecto: proyectohtml,
          puntos: puntos,
          categoria: categoria,
          imagen: imagen,
          activo: true,
          requerimientos: requerimientos,
          isHtml: isHtml,
          isCss: isCss,
          isJs: isJs,
          reqHtml,
          reqCss,
          reqJs,
          limite: state.tiempo_limite,
          tipoProyecto: tipoProyecto,
          fechaInicio: new Date(),
          tutoria: tutoria,
          secciones,
          codigo
        });
      commit("subirProyectoUsuario", proyectos);
    } else if (tipo === "seguimiento") {
      let proyectos = await firestore
        .collection("usuarios")
        .doc(idUser)
        .collection("proyectos_usuario")
        .doc(idProyectoUsuario)
        .update({
          idProyecto: idProyecto,
          idUser: idUser,
          idProyectoUsuario: idProyectoUsuario,
          nombreUsuario: nombreUsuario,
          username: username,
          titulo: titulo,
          area: area,
          sub_area: sub_area,
          proyecto: proyectohtml,
          puntos: puntos,
          categoria: categoria,
          imagen: imagen,
          activo: true,
          requerimientos: requerimientos,
          isHtml: isHtml,
          isCss: isCss,
          isJs: isJs,
          reqHtml,
          reqCss,
          reqJs,
          limite: state.tiempo_limite,
          tipoProyecto: tipoProyecto,
          fechaInicio: new Date(),
          terminado: false,
          activo: true,
          carpeta: [],
          veces: 0,
          tutoria: tutoria,
        });
      commit("subirProyectoUsuario", proyectos);
    }
  },

  async proyectoUsuarioBackend(
    { commit, state },
    {
      idUser,
      nombreUsuario,
      username,
      idProyecto,
      idProyectoUsuario,
      titulo,
      area,
      sub_area,
      proyectohtml,
      puntos,
      categoria,
      imagen,
      tipoProyecto,
      nivel,
      niveles,
      tipo,
    }
  ) {
    if (tipo === "inicial") {
      let proyectos = await firestore
        .collection("usuarios")
        .doc(idUser)
        .collection("proyectos_usuario")
        .doc(idProyectoUsuario)
        .set({
          idProyecto: idProyecto,
          idUser: idUser,
          idProyectoUsuario: idProyectoUsuario,
          nombreUsuario: nombreUsuario,
          username: username,
          titulo: titulo,
          area: area,
          sub_area: sub_area,
          proyecto: proyectohtml,
          puntos: puntos,
          categoria: categoria,
          imagen: imagen,
          tipoProyecto: tipoProyecto,
          nivel: nivel,
          niveles: niveles,
          limite: state.tiempo_limite,
          fechaInicio: new Date(),
          terminado: false,
          activo: true,
        });
      commit("subirProyectoUsuario", proyectos);
    } else if (tipo === "seguimiento") {
      let proyectos = await firestore
        .collection("usuarios")
        .doc(idUser)
        .collection("proyectos_usuario")
        .doc(idProyectoUsuario)
        .update({
          idProyecto: idProyecto,
          idUser: idUser,
          idProyectoUsuario: idProyectoUsuario,
          nombreUsuario: nombreUsuario,
          username: username,
          titulo: titulo,
          area: area,
          sub_area: sub_area,
          proyecto: proyectohtml,
          puntos: puntos,
          categoria: categoria,
          imagen: imagen,
          tipoProyecto: tipoProyecto,
          nivel: nivel,
          niveles: niveles,
          limite: state.tiempo_limite,
          fechaInicio: new Date(),
          terminado: false,
          activo: true,
          veces: 0,
        });
      commit("subirProyectoUsuario", proyectos);
    }
  },
  
  
  async eliminarArchivoHtmlCss(context, { urlArchivo }) {
    try {
      // Obtén la referencia al archivo en base a la URL proporcionada
      const archivoRef = storage.refFromURL(urlArchivo);

      // Elimina el archivo
      await archivoRef.delete();
    } catch (error) {
      console.error("Error al eliminar el archivo:", error);
    }
  },

  async actualizarPuntaje(context, { id, totalPuntos }) {
    const data = {};
    data.totalPuntos = totalPuntos;

    await firestore.collection("usuarios").doc(id).update(data);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
